module.exports = __webpack_public_path__ + "img/janopay_creditcard_03.228ceb75.png";